import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "el-scrollbar-fade" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", {
        ref: "instance",
        class: _normalizeClass(['el-scrollbar__bar', 'is-' + _ctx.bar.key]),
        onMousedown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickTrackHandler && _ctx.clickTrackHandler(...args)))
      }, [
        _createElementVNode("div", {
          ref: "thumb",
          class: "el-scrollbar__thumb",
          style: _normalizeStyle(_ctx.thumbStyle),
          onMousedown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickThumbHandler && _ctx.clickThumbHandler(...args)))
        }, null, 36)
      ], 34), [
        [_vShow, _ctx.visible]
      ])
    ]),
    _: 1
  }))
}